<template>
  <div class="place-order">
    <!-- 头部 -->
    <LifeTopbar :title="title" />

    <div class="unit">
		<!-- 选择单位 - ptype7 使用底部弹窗避免下拉遮挡问题 -->
		<div v-if="isPtype7 && unitList[0].list.length > 0" class="ptype7-selector place-order-form" @click="openPtype7Dialog">
			<div class="ptype7-trigger-item">
				<div class="ptype7-trigger-title">{{ unitList[0].title || '缴费项目' }}</div>
				<div class="ptype7-trigger-value" :class="{ 'has-value': unitList[0].name }">
					{{ unitList[0].name || (unitList[0].tips || '请选择缴费项目') }}
				</div>
			</div>
		</div>
		<!-- 选择单位（非ptype7） -->
		<LifeForm v-else-if="!isEsimNew && unitList[0].list.length > 1" :value.sync="unit" :list.sync="unitList"  />
		<!-- eSIM-New 国家选择入口 -->
		<div v-if="isEsimNew" class="place-order-form country-selector" @click="openCountryDialog">
			<LifeForm :value.sync="fakeCountryForm" :list.sync="fakeCountryFormList" />
		</div>
		<!-- eSIM 卡选择（显示在国家之后） -->
		<div v-if="isEsimNew && iccidFormList[0] && iccidFormList[0].list && iccidFormList[0].list.length > 0" class="place-order-form">
			<LifeForm :value.sync="iccidForm" :list.sync="iccidFormList" />
		</div>
		<!-- 选择套餐 -->
    	<div v-if="packageSelect.length > 1" class="sub">
    		<div v-for="(item, index) in packageSelect" @click="tap(item)"
    		:class="{ active: packageAct.id === item.id }" class="item">
				<div v-if="item.ptype == 5 || item.ptype == 6" class="package-price">
    				{{Number(item.amount) > 0 ? '₱':'$'}}{{Number(item.amount) > 0 ? item.amount: item.doller}}
    			</div>
    			<div class="name">
    				{{item.name}}
    			</div>
    		</div>
    	</div>
    </div>

    <!-- 通过套餐param得到的表单 -->
    <div v-if="formList.length > 0" class="place-order-form">
    	<LifeForm :value.sync="form" :list.sync="formList" @listChange="listChange"  />
    </div>

    <!-- 缴费金额（ptype7 的 amount 已在动态表单中，无需单独显示） -->
    <div v-if="!isPtype7" class="place-order-form">
    	<LifeForm :value.sync="priceForm" :list.sync="priceFormList" />
    </div>
    <!-- 手续费 -->
    <div v-if="packageAct && packageAct.id && !isEsimNew" class="place-order-form">
    	<LifeForm :value.sync="servicePriceForm" :list.sync="serviceFormList" />
    </div>

    <!-- Meralco 电费（FORTUNE 默认选中 ID=1690）缴费示例图 -->
    <div v-if="packageAct && String(packageAct.id) === '1690'" class="meo-tips" @click="meoView">
    	<img src="/static/images/lifePay/meo1.png" />
    </div>

    <!-- 充值表单 -->
   <!-- <div class="place-order-form">
      <LifeForm v-model="form" :list="formList" />
    </div> -->

    <!-- 充值额度选择 -->
   <!-- <div v-if="isLife === 2" class="place-order-etc">
      <div class="etc-select-title">选择充值额度</div>
      <lifeAmount v-model="price" :list="amountList"
      height="39px" />
    </div> -->

    <!-- 代金券优惠码 -->
    <!-- <div v-if="isLife === 2" class="coupon-code flex_column">
    	<div class="life-form-item flex_justry_center">
    		<div class="form-item-value code-input flex_1">
    			<input v-model="couponCode" placeholder="请输入代金券优惠码" placeholder-class="pdr9"
    			type="text" />
    		</div>
    		<div class="form-item-title code-btn" @click="checkCode">校验优惠码</div>
    	</div>
    	<div v-show="isCheck">
    		<div class="life-form-item flex_justry_center">
    			<div class="form-item-title">优惠金额</div>
    			<div class="form-item-value flex_1">
    				<span>P{{discountAmount}}</span>
    			</div>
    		</div>
    		<div class="life-form-item flex_justry_center">
    			<div class="form-item-title">应付金额</div>
    			<div class="form-item-value flex_1">
    				<span>P{{payableAmount}}</span>
    			</div>
    		</div>
    	</div>
    </div> -->

    <!-- 支付方式选择 -->
    <div v-if="configPayments && configPayments.length > 0" class="place-order-form">
      <LifeForm :value.sync="paymentForm" :list.sync="paymentFormList" />
    </div>

    <!-- 充值须知 -->
    <div class="place-order-notice">
      <lifeNotice />
    </div>

    <el-dialog title="请使用扫码支付" :visible.sync="centerDialogVisible"
    width="300px" center>
      <div>
        <vue-qr :text="downloadData.url" :margin="10" colorDark="#000" colorLight="#fff"
        :dotScale="1" :logoSrc="downloadData.icon" :logoScale="0.2" :size="200" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <lifePreview v-model="show" :list="viewList" />

    <!-- 充值提交 -->
    <lifeSubmit :loading="isOrder" :title="isOrder ? loadTitle: '确认支付'" @submit="submitOrder" />
    
    <!-- ptype7 缴费项目选择弹窗 -->
    <div v-if="ptype7DialogVisible" class="ptype7-overlay" @click.self="ptype7DialogVisible = false">
      <div class="ptype7-sheet">
        <div class="ptype7-sheet-header">
          <div class="ptype7-sheet-title">选择缴费项目</div>
          <div class="ptype7-sheet-close" @click="ptype7DialogVisible = false">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div class="ptype7-sheet-search">
          <input v-model="ptype7SearchKeyword" type="text" placeholder="搜索缴费项目" class="ptype7-search-input" />
        </div>
        <div class="ptype7-sheet-list">
          <div v-for="item in filteredPtype7Options" :key="item.id"
               class="ptype7-list-item"
               :class="{ active: unit.id == item.id }"
               @click="selectPtype7Option(item)">
            {{ item.name }}
          </div>
          <div v-if="filteredPtype7Options.length === 0" class="ptype7-empty">无匹配项目</div>
        </div>
      </div>
    </div>

    <!-- 国家选择弹窗（eSIM 专用） - 全屏弹窗 -->
    <div v-if="countryDialogVisible" class="country-overlay" @click.self="countryDialogVisible = false">
      <div class="country-sheet">
        <div class="country-picker-header">
          <div class="header-space"></div>
          <div class="header-title">选择国家</div>
          <div class="close-button" @click="countryDialogVisible = false">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div class="country-search">
          <input
            v-model="countrySearchKeyword"
            type="text"
            placeholder="搜索国家"
            class="country-search-input"
          />
        </div>
        <div class="country-picker">
          <div class="left-pane">
            <div :class="['left-item', selectedContinentId === 'all' ? 'active' : '']" @click="selectContinent('all')">全部</div>
            <div v-for="c in continents" :key="c.id" :class="['left-item', selectedContinentId === c.id ? 'active' : '']" @click="selectContinent(c.id)">{{ c.name }}</div>
          </div>
          <div class="right-pane">
            <div v-for="co in filteredCountries" :key="co.id" :class="['right-item', selectedCountry && selectedCountry.id === co.id ? 'active' : '']" @click="selectCountry(co)">{{ co.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LifeTopbar from '@/components/life-topBar.vue'
  import LifeForm from '@/components/life-form.vue'
  import lifeSelect from '@/config/lifeSelect.js'
  import lifeAmount from '@/components/life-amount.vue'
  import lifeNotice from '@/components/life-notice.vue'
  import lifeSubmit from '@/components/life-submit.vue'
  import lifePreview from '@/components/life-preview.vue'
  import vueQr from 'vue-qr'
  import cal from '@/util/calculation.js'

  const delay = (function() {
    let timer = 0
    return function(callback, ms) {
      setTimeout(() => {
        clearInterval(timer)
      }, 1000 * 60 * 5)
      if (timer) clearInterval(timer)
      timer = setInterval(callback, ms)
    }
  })()

  export default {
    components: {
      LifeTopbar,
      LifeForm,
      lifeAmount,
      lifeNotice,
      lifeSubmit,
      lifePreview,
      vueQr
    },
    data() {
      return {
        centerDialogVisible: false,
        downloadData: {
          url: '', //需要转化成二维码的网址
        },
        // eSIM-New（ID=89）专用
        isEsimNew: false,
        countryDialogVisible: false,
        continents: [],
        countriesAll: [],
        selectedContinentId: 'all',
        selectedCountry: null,
        // 用于展示国家的假表单（仅用于复用 LifeForm 的样式展示当前国家）
        fakeCountryForm: {},
        fakeCountryFormList: [{
          type: 'select',
          key: 'country',
          title: '国家',
          value: '',
          name: '',
          list: []
        }],
        unit: {
        	id: '' //当前单位id(通过它得到套餐选择列表，只有单项默认选中)
        },
        unitList: [{ //缴费单位选择列表
        	key: 'id',
        	title: '缴费单位',
        	value: '',
        	tips: '请选择缴费单位',
        	type: 'select',
          name: '',
        	list: []
        }],
        packageSelect: [], //套餐选择列表
        packageAct: { //选中的套餐
        	service_fee: 0
        },
        priceForm: {}, //缴费金额表单值
        priceFormList: [{ //缴费金额表单列表
        	type: 'input',
        	isNumber: true,
          inputType: 'digit',
        	title: '缴费金额（披索₱）',
        	key: 'price',
        	value: '',
        	tips: '在此输入账单金额',
        	disabled: false
        }],
        servicePriceForm: {}, //手续费表单值
        serviceFormList: [{
        	type: 'text',
        	title: '手续费（披索₱）',
        	key: 'service_price',
        	value: '',
        	name: '',
        	disabled: true // 手续费不可编辑
        }],
        // 通过选择套餐得到的表单值
        paramsForm: {},
        title: '',
        formList: [],
        form: {},

        amountList: [],
        amountLoad: [],
        price: '', //充值金额
        isPtype7: false, // FortunePay 生活缴费（水/电/网/高速）
        ptype7Products: [], // FortunePay 产品完整列表（用于watcher中查找）
        ptype7DialogVisible: false, // 缴费项目选择弹窗
        ptype7SearchKeyword: '', // 搜索关键词
        isOrder: false,
        // idPlactype: true,
        // accountKey: 'Account',
        // idfKey: 'Identifier',
        // couponCode: '', //优惠码
        // discountAmount: 0, //优惠金额
        // payableAmount: 0, //应付金额
        // sxfAmount: 50, //手续费
        // isCheck: false, //校验通过显示金额
        codetoken: '',
        loadTitle: '支付请求中',
        show: false,
        viewList: ['/static/images/lifePay/meo2.png'],
        countrySearchKeyword: '', // 国家搜索关键词
        // eSIM 卡选择
        iccidForm: {},
        iccidFormList: [{
          key: 'iccid',
          title: 'eSIM 卡',
          value: '',
          type: 'select',
          tips: '请选择 eSIM 卡',
          list: []
        }],
        // 支付方式相关
        configPayments: [],
        payment: '',
        paymentForm: {},
        paymentFormList: [{
          key: 'payment',
          title: '支付方式',
          value: '',
          type: 'select',
          tips: '请选择支付方式',
          name: '',
          list: []
        }]
      }
    },
    computed: {
      isLife() {
        return this.$store.state.isLife
      },
      orderTips() {
      	return this.$store.state.orderTips
      },
      menuList() {
      	return this.$store.state.rechargeCategory
      },
      // ptype7 缴费项目搜索过滤
      filteredPtype7Options() {
        const keyword = (this.ptype7SearchKeyword || '').trim().toLowerCase()
        const options = this.unitList[0].list || []
        if (!keyword) return options
        return options.filter(item => (item.name || '').toLowerCase().includes(keyword))
      },
      // eSIM-New 右侧国家列表
      filteredCountries() {
        if (!this.isEsimNew) return []
        const keyword = (this.countrySearchKeyword || '').trim().toLowerCase()
        let source = []
        if (this.selectedContinentId === 'all') source = this.countriesAll
        else {
          const cont = this.continents.find(c => c.id === this.selectedContinentId)
          if (cont && Array.isArray(cont.children)) source = cont.children
        }
        if (!keyword) return source
        return source.filter(co => {
          const n = (co.name || '').toLowerCase()
          const en = (co.enname || '').toLowerCase()
          return n.includes(keyword) || en.includes(keyword)
        })
      }
    },
    watch: {
      // 缴费单位变化
      'unit.id': {
      	handler(newVal) {
      		if (!newVal) return
      		this.packageAct = {}
          this.formList = []
          this.paramsForm = {}
      		// ptype7: 直接从产品列表找到对应产品，构建动态表单
      		if (this.isPtype7) {
      			const product = this.ptype7Products.find(item => item.id == newVal)
      			if (product) {
      				this.packageAct = product
      				this.analysisPtype7(product.param)
      			}
      			return
      		}
      		// 通过单位id得到对应的套餐列表
      		const { list } = this.unitList[0]
      		const { products } = list.find(item => item.id === newVal)
      		// eSIM: 根据卡选择过滤产品类型
      		if (this.isEsimNew && products) {
      			const isNewPurchase = !this.iccidForm.iccid
      			const filterType = isNewPurchase ? 'topup' : 'sim'
      			const filtered = products.filter(p => p.type === filterType)
      			this.packageSelect = filtered.length > 0 ? filtered : products
      		} else {
      			this.packageSelect = products
      		}
      		console.log('packageSelect:', this.packageSelect)
      		this.packageAct = this.packageSelect[0]
      	},
      	deep: true
      },
      // eSIM卡切换时重新过滤产品（仅在筛选类型变化时触发）
      'iccidForm.iccid': {
      	handler(newVal, oldVal) {
      		if (!this.isEsimNew || !this.unit.id) return
      		// 只有 新购↔续费 切换时才重新过滤（避免 buildEsimIccidSelect 引起的循环）
      		const newType = !newVal ? 'topup' : 'sim'
      		const oldType = !oldVal ? 'topup' : 'sim'
      		if (newType === oldType) return
      		const { list } = this.unitList[0]
      		const found = list.find(item => item.id === this.unit.id)
      		if (!found || !found.products) return
      		const filtered = found.products.filter(p => p.type === newType)
      		this.packageSelect = filtered.length > 0 ? filtered : found.products
      		this.packageAct = this.packageSelect[0]
      	},
      	deep: true
      },
      // 选择套餐变化
      packageAct: {
      	handler(newVal) {
      		console.log('packageAct:', newVal)
      		if (!newVal) return
      		this.$set(this.priceFormList[0], 'value', '')
      		// 同步清空 priceForm.price，确保手续费计算时金额为0
      		this.$set(this.priceForm, 'price', '')
      		// amount=0价格文本框才能输入
      		if (Number(newVal.amount) === 0 && Number(newVal.doller) === 0) {
      			this.$set(this.priceFormList[0], 'disabled', false)
      		} else {
      			this.$set(this.priceFormList[0], 'disabled', true)
      		}

      		// 根据不同ptype值处理param得到账号表单
          switch(Number(newVal.ptype)) {
            case 5: //esim 老逻辑
              this.analysisPtype5(newVal.param)
              break;
            case 6: // eSIM-New: 需要选择 iccid（仅首次加载时构建列表）
              this.formList = []
              if (!this.iccidFormList[0].list || this.iccidFormList[0].list.length === 0) {
                this.buildEsimIccidSelect()
              }
              break;
      		}

      		if (Number(newVal.amount) > 0) {
      			this.$set(this.priceFormList[0], 'value', newVal.amount)
      			// 同步更新 priceForm.price
      			this.$set(this.priceForm, 'price', newVal.amount)
      			// 重新计算手续费
      			this.calculateServiceFee()
      			return
      		}
      		// 查询美元接口
      		if (newVal.doller && Number(newVal.doller) > 0) {
      			this.getQueryAmount(newVal.id)
      			// 查询完成后会通过 priceForm.price 的 watch 自动计算手续费
      			return
      		}
      		// 手动输入金额的情况，确保手续费为0
      		this.$nextTick(() => {
      			this.calculateServiceFee()
      		})
      	},
      	deep: true
      },
      // 缴费金额变化
      'priceForm.price': {
      	handler(newVal) {
      		console.log('priceForm.price changed:', newVal, 'packageAct:', this.packageAct)
      		// 使用新的手续费计算规则
      		console.log('准备调用 calculateServiceFee')
      		this.calculateServiceFee()
      		console.log('calculateServiceFee 调用完成')
      	},
      	deep: true,
      	immediate: true
      },
      // price(newVal) { //其它缴费金额变化(Crab等)
      // 	// 金额变化修改手续费
      // 	if (!newVal) return
      // 	const { fee } = this.amountLoad.find(item => item.amount === newVal)
      // 	const feeIndex = this.formList.findIndex(item => item.key === 'service_price')
      // 	if (feeIndex === -1) return
      // 	const copyItem = JSON.parse(JSON.stringify(this.formList[feeIndex]))
      // 	copyItem.value = fee
      // 	copyItem.name = `P${fee}`
      //   this.sxfAmount = fee
      // 	this.$set(this.formList, feeIndex, copyItem)
      //   // 金额变化，重置金额
      //   this.payableAmount = 0
      //   this.discountAmount = 0
      //   this.couponCode = ''
      //   this.codetoken = ''
      //   this.isCheck = false
      // },
      // 'form.accountNumber': {
      // 	handler(newVal) {
      // 		if (!newVal) return
      // 		const numIndex = this.formList.findIndex(item => item.key === 'accountNumber')
      // 		if (newVal.length === 1) {
      // 			switch(newVal) {
      // 				case '0':
      // 					return
      // 					break;
      // 				case '9':
      // 					const unNumber = `0${newVal}`
      // 					this.setFormData(numIndex, 'value', unNumber)
      // 					return
      // 					break;
      // 				default:
      // 					this.setFormData(numIndex, 'value', '')
      // 			}
      // 		} else {
      // 			if (newVal.slice(0, 2) === '09') return
      // 			else this.setFormData(numIndex, 'value', '')
      // 		}
      // 	},
      // 	deep: true
      // }
      // 监听支付方式变化
      'paymentForm.payment': {
      	handler(newVal) {
      		if (newVal) {
      			this.payment = newVal
      			console.log('支付方式已选择:', newVal)
      		}
      	},
      	deep: true,
      	immediate: true
      }
    },
    created() {
      this.init()
      this.getConfigPayments()
    },
    methods: {
      // 获取配置的支付方式列表
      async getConfigPayments() {
        try {
          const { data } = await this.$api.request('System/init', {
            position: 1,
            client: this.$client
          })
          if (typeof data.config_payments == 'object' && Array.isArray(data.config_payments)) {
            this.$set(this, 'configPayments', data.config_payments)
            // 构建下拉列表
            const paymentList = data.config_payments.map(item => ({
              id: item.code,
              name: item.name,
              icon: item.icon || ''
            }))
            this.$set(this.paymentFormList[0], 'list', paymentList)
            // 默认选择第一个
            if (paymentList.length > 0) {
              const first = paymentList[0]
              this.$set(this.paymentFormList[0], 'value', first.id)
              this.$set(this.paymentFormList[0], 'name', first.name)
              this.payment = first.id
              this.$set(this.paymentForm, 'payment', first.id)
            }
          }
        } catch (error) {
          console.error('获取支付方式列表失败:', error)
        }
      },
      // 计算手续费
      calculateServiceFee() {
      	// ID=89 eSIM 不计算手续费
      	if (this.isEsimNew) {
      		const filterIndex = this.serviceFormList.findIndex(item => item.key === 'service_price')
      		if (filterIndex !== -1) {
      			this.$set(this.serviceFormList[filterIndex], 'value', 0)
      			this.$set(this.serviceFormList[filterIndex], 'name', '')
      			this.$set(this.servicePriceForm, 'service_price', 0)
      		}
      		return
      	}
      	if (!this.packageAct || !this.packageAct.id) {
      		const filterIndex = this.serviceFormList.findIndex(item => item.key === 'service_price')
      		if (filterIndex !== -1) {
      			this.$set(this.serviceFormList[filterIndex], 'value', 0)
      			this.$set(this.serviceFormList[filterIndex], 'name', '')
      			this.$set(this.servicePriceForm, 'service_price', 0)
      		}
      		return
      	}

      	let serviceCharge = 0

      	if (this.isPtype7) {
      		// FortunePay 规则：≤3000 固定50，>3000 收取2%
      		const amount = Number(this.paramsForm.amount) || 0
      		if (amount > 0) {
      			serviceCharge = amount <= 3000 ? 50 : Math.round(amount * 0.02)
      		}
      	} else {
      		const packageAct = this.packageAct
      		const priceVal = this.priceForm.price ? Number(this.priceForm.price) : 0
      		const hasProductPrice = (packageAct.amount && Number(packageAct.amount) > 0) ||
      		                        (packageAct.doller && Number(packageAct.doller) > 0)
      		if (hasProductPrice) {
      			serviceCharge = 20
      		} else if (priceVal > 0) {
      			serviceCharge = Math.round(priceVal * 0.07 * 100) / 100
      		}
      	}

      	const filterIndex = this.serviceFormList.findIndex(item => item.key === 'service_price')
      	if (filterIndex !== -1) {
      		this.$set(this.serviceFormList[filterIndex], 'value', serviceCharge)
      		this.$set(this.serviceFormList[filterIndex], 'name', serviceCharge > 0 ? `₱${serviceCharge}` : '')
      		this.$set(this.servicePriceForm, 'service_price', serviceCharge)
      	}
      },
      // 打开/关闭 ptype7 缴费项目选择弹窗
      openPtype7Dialog() {
        this.ptype7SearchKeyword = ''
        this.ptype7DialogVisible = true
      },
      selectPtype7Option(item) {
        this.$set(this.unitList[0], 'value', item.id)
        this.$set(this.unitList[0], 'name', item.name)
        this.$set(this.unit, 'id', item.id)
        this.ptype7DialogVisible = false
      },
      // 打开国家选择弹窗
      openCountryDialog(e) {
        e.stopPropagation()
        e.preventDefault()
        this.countryDialogVisible = true
      },
      meoView() {
        this.show = true;
      },
      // 查询披索价格
      getQueryAmount(product_id) {
      	// uni.showLoading({
      	// 	title: '缴费金额查询中...'
      	// });
      	this.loadTitle = '查询缴费金额中'
      	this.isOrder = true

        this.$api.request('Order/queryAmount', {
            product_id
        }).then(res => {
            this.$set(this.priceFormList[0], 'value', res.data)
            this.isOrder = false
        }).catch(error => {
            this.formMsg(error)
            this.isOrder = false
        })
      },
      // 生活缴费字段名/英文 label 汉化（eSIM 不使用）
      // 策略：label 优先（label 含语义，更具体），field 兜底。归一化剥离位数前后缀、括号格式提示、统一 w/dash 写法
      translateFieldLabel(field, label) {
        const labelMap = {
          'amount': '缴费金额',
          'account name': '户名',
          'account name on water bill': '户名',
          'account name in water bill': '户名',
          'account no': '账号',
          'account number': '账号',
          'account no with dash': '账号（含短横线）',
          'account no with dashes': '账号（含短横线）',
          'account number with dash': '账号（含短横线）',
          'account number with dashes': '账号（含短横线）',
          'customer account no': '客户账号',
          'customer account number': '客户账号',
          'biller account no': '账号',
          'biller account number': '账号',
          'subscriber account no': '订户账号',
          'subscriber account number': '订户账号',
          'contract account number': '合同账号',
          'service account number': '服务账号',
          'reference no': '参考号',
          'reference number': '参考号',
          'reference code': '参考码',
          'atm reference no': 'ATM 参考号',
          'atm reference number': 'ATM 参考号',
          'registered account name': '注册户名',
          'mobile number': '手机号',
          'mobile no': '手机号',
          'contact number': '联系号码',
          'customer number': '客户号',
          'customer code': '客户号',
          'customer name': '客户姓名',
          'consumer name': '用户姓名',
          'consumer code': '用户号',
          'account code': '账号',
          'control number': '控制号',
          'id number': '证件号',
          'win': '水账号',
          'meter number': '电表号',
          'soa number': 'SOA编号',
          'biller account name': '账户名称',
          'biller tag': '缴费类型',
          'policy number': '保单号',
          'invoice number': '发票号',
          'bill number': '账单号',
          'bill no': '账单号',
          'bill mo': '账单月',
          'bill month': '账单月',
          'bill year': '账单年',
          'subscriber number': '订户号',
          'subscriber id': '订户编号',
          'due date': '到期日',
          'bill date': '账单日期',
          'address': '地址',
          'tin': '税号',
          'remarks': '备注',
          'email': '邮箱',
          'phone': '电话',
          'name': '姓名',
          'full name': '姓名',
          'first name': '名',
          'last name': '姓',
          'middle name': '中间名',
          'surname, first name': '姓名（姓，名）',
          'surname, given name': '姓名（姓，名）',
          'last name, first name': '姓名（姓，名）',
          'birth date': '出生日期',
          'plate number': '车牌号',
          'plan code': '计划代码'
        }
        const fieldMap = {
          amount: '缴费金额',
          accountNo: '账号',
          accountNumber: '账号',
          account: '账号',
          customerAccountNumber: '客户账号',
          billerAccountNumber: '账号',
          subscriberAccountNumber: '订户账号',
          accountName: '户名',
          customerName: '客户姓名',
          consumerName: '用户姓名',
          fullName: '姓名',
          firstName: '名',
          lastName: '姓',
          middleName: '中间名',
          contractAccountNumber: '合同账号',
          serviceAccountNumber: '服务账号',
          meterNumber: '电表号',
          referenceNumber: '参考号',
          referenceNo: '参考号',
          referenceCode: '参考码',
          atmReferenceNumber: 'ATM 参考号',
          atmReferenceNo: 'ATM 参考号',
          registeredAccountName: '注册户名',
          mobileNumber: '手机号',
          phone: '电话',
          email: '邮箱',
          address: '地址',
          soaNumber: 'SOA编号',
          billerAccountName: '账户名称',
          billerTag: '缴费类型',
          policyNumber: '保单号',
          invoiceNumber: '发票号',
          billNumber: '账单号',
          billNo: '账单号',
          subscriberNumber: '订户号',
          subscriberId: '订户编号',
          dueDate: '到期日',
          billDate: '账单日期',
          birthDate: '出生日期',
          plateNumber: '车牌号',
          tin: '税号',
          remarks: '备注',
          planCode: '计划代码'
        }
        const normalizePart = (s) => String(s).trim().toLowerCase()
          .replace(/\bw\s*[\\\/]+\s*dash(?:es)?\b/g, 'with dash')
          .replace(/\(\s*with\s+dash(?:es)?\s*\)/g, 'with dash')
          .replace(/^\d+(?:\s*-\s*\d+)?\s*-?\s*digit[s]?\s+/, '')
          .replace(/^\d+\s*-\s*\d+\s+(?=[a-z])/, '')
          .replace(/\s*\(\d+(?:\s*-\s*\d+)?\s*digit[s]?\)\s*/g, ' ')
          .replace(/\s*[-–]\s*\d+(?:\s*-\s*\d+)?\s*digit[s]?\s*/g, ' ')
          .replace(/\s*\([^)]*\)\s*/g, ' ')
          .replace(/\./g, '')
          .replace(/\s+/g, ' ')
          .trim()
        // 翻译单段 label；非位数/非 with-dash 的括号（如 "(mmyyyy)"）作为格式提示追加到翻译末尾
        const translateSingle = (lbl, keepDigit) => {
          if (!lbl) return null
          let digits = ''
          if (keepDigit) {
            const m = lbl.match(/^(\d+(?:\s*-\s*\d+)?)\s*-?\s*digit[s]?\s+/i)
            if (m) digits = m[1].replace(/\s+/g, '')
          }
          let fmtHint = ''
          const paren = lbl.match(/\(([^)]*)\)/)
          if (paren) {
            const inner = paren[1].trim()
            const isDigit = /^\s*\d+(?:\s*-\s*\d+)?\s*digit[s]?\s*$/i.test(inner)
            const isWithDash = /^\s*with\s+dash(?:es)?\s*$/i.test(inner)
            if (inner && !isDigit && !isWithDash) fmtHint = '（' + inner + '）'
          }
          const norm = normalizePart(lbl)
          const hit = labelMap[norm]
          if (hit != null) {
            const r = digits ? (digits + '位' + hit) : hit
            return r + fmtHint
          }
          return null
        }
        if (label) {
          if (label.indexOf('+') >= 0) {
            const parts = label.split(/\s*\+\s*/).map(p => p.trim()).filter(Boolean)
            if (parts.length >= 2) {
              const translated = parts.map(p => translateSingle(p, true) || p)
              if (parts.some(p => translateSingle(p, true) != null)) {
                return translated.join('+')
              }
            }
          }
          const single = translateSingle(label, false)
          if (single != null) return single
        }
        if (field && fieldMap[field]) return fieldMap[field]
        return label || field || ''
      },
      // 将下划线命名转换为标题格式，例如：account_number -> Account Number
      toTitleCase(str) {
      	if (!str) return ''
      	// 将下划线命名转换为空格分隔的标题
      	return str
      		.split('_') // 按下划线分割
      		.map(word => {
      			// 将每个单词的首字母大写，其余小写
      			return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      		})
      		.join(' ') // 用空格连接
      },

      // 处理ptype=5的param
      analysisPtype5(param) {
      	if (!param) return this.formList = []
      	// 得到ptype5表单列表
      	const newParam = JSON.parse(param)
      	// console.log(newParam)
      	const keys = Object.keys(newParam)
      	const values = Object.values(newParam)
      	const list = []
      	keys.forEach((item, index) => {
      		if (values[index]) {
      			const findList = values[index][0]
      			findList.forEach(ite => {
      				list.push({
      					key: ite, //当前键名
      					title: this.toTitleCase(ite), //标题
      					value: '', //当前输入值
      					firsKey: item, //上级键名(所属键名)
      					type: 'input', //当前类型
      					tips: '请输入' //提示文字
      				})
      			})
      		}
      	})
      	this.formList = list
      },
      // 套餐选择
      tap(item) {
      	this.packageAct = item
      },
      // 套餐表单变化
      listChange(list) {
      	const newParams = this.paramsForm
      	list.forEach(item => {
      		if (item.firsKey) {
      			if (!newParams[item.firsKey]) {
      				newParams[item.firsKey] = {}
      			}
      			newParams[item.firsKey][item.key] = item.value
      		} else {
      			newParams[item.key] = item.value
      		}
      		this.$set(this, 'paramsForm', newParams)
      	})
      	// ptype7: amount 变化时实时重新计算手续费
      	if (this.isPtype7) {
      		this.calculateServiceFee()
      	}
      },
      // 校验优惠码
      // async checkCode() {
      // 	if (!this.couponCode) return this.formMsg('请输入优惠码')
      // 	if (!this.price) return this.formMsg('请选择充值金额')
      // 	const res = await this.checkRequest(this.couponCode)
      // 	// console.log(res)
      // 	if (!res) return
      // 	const { codemoney, codetoken } = res.data
      // 	this.payableAmount = codemoney
      // 	const sumPrice = cal.accAdd(this.price, this.sxfAmount)
      // 	this.discountAmount = cal.accSub(sumPrice, codemoney)
      // 	this.codetoken = codetoken
      // 	this.isCheck = true
      // 	this.formMsg(res.msg)
      // },
      // 验证码校验请求
      // checkRequest(code) {
      // 	return new Promise((resolve, reject) => {
      //     const money = cal.accAdd(this.price, this.sxfAmount)
      //     this.$api.request('Order/verifyPromoCode', {
      //       type: 2, // type=1 话费 type=2 转账
      //       money,
      //       channel: this.type,
      //       code
      //     }).then(res => {
      //       resolve(res)
      //     }).catch(error => {
      //       reject(error)
      //       this.formMsg(error)
      //     })
      // 	})
      // },
      // 提交订单
      submitOrder() {
            if (this.isPtype7) {
              // FortunePay 生活缴费提交逻辑
              if (!this.unit.id) return this.formMsg('请选择缴费项目')
              const requiredFields = this.formList.filter(f => f.required)
              for (const field of requiredFields) {
                const val = this.paramsForm[field.key]
                if (val === undefined || val === null || String(val).trim() === '') {
                  return this.formMsg('请补全并填写正确的账单信息')
                }
              }
              if (!this.paramsForm.amount || Number(this.paramsForm.amount) <= 0) {
                return this.formMsg('请填写缴费金额')
              }
              this.loadTitle = '支付请求中'
              const data = {
                itemid: this.packageAct.id,
                params: JSON.stringify(this.paramsForm),
                client: this.$client,
                price: String(this.paramsForm.amount)
              }
              data.type = 1
              if (this.payment) { data.payment = this.payment }
              if (this.$client == 'magapp') { data.payment = 'magapay' }
              const servicePriceItem = this.serviceFormList.find(item => item.key === 'service_price')
              const servicePrice = this.servicePriceForm.service_price || (servicePriceItem && servicePriceItem.value) || 0
              if (servicePrice > 0) { data.service_price = servicePrice }
              this.$confirm(this.orderTips, '特别提醒', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.isOrder = true
                this.$api.request('Order/rechargeCreate', data)
                  .then(({ data }) => { this.orderSuccess(data) })
                  .catch(error => { this.isOrder = false; this.formMsg(error) })
              }).catch(() => {})
              return
            }

            if (!this.unit.id) return this.formMsg('请选择缴费单位')
            if (!this.packageAct.id) return this.formMsg('请选择套餐')
            if (Object.values(this.form).some(item => !item)) {
            	this.formMsg('请补全并填写正确的账单信息')
            	return
            }
            if (!this.priceForm.price) return this.formMsg('请填写缴费金额')
            this.loadTitle = '支付请求中'
            // ptype=6 (eSIM-New) 需要将 iccid 添加到 paramsForm
            const submitParams = { ...this.paramsForm }
            if (this.packageAct.ptype == 6 && this.iccidForm.iccid) {
            	submitParams.iccid = this.iccidForm.iccid
            }
            const data = {
            	itemid: this.packageAct.id,
            	params: JSON.stringify(submitParams),
            	client: this.$client,
            	...this.priceForm
            }
            
            data.type = 1
            if (this.payment) {
              data.payment = this.payment
            }
            
            // magapp 特殊处理
            if(this.$client == 'magapp') {
              data.payment = 'magapay'
            }
            // 提交手续费（所有订单都需要提交手续费）
            const servicePriceItem = this.serviceFormList.find(item => item.key === 'service_price')
            const servicePrice = this.servicePriceForm.service_price || (servicePriceItem && servicePriceItem.value) || 0
            if (servicePrice > 0) {
            	data.service_price = servicePrice
            }

            console.log('----提交数据--->', data);
            this.$confirm(this.orderTips, '特别提醒', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.isOrder = true;
              this.$api.request('Order/rechargeCreate', data)
              .then(({ data }) => {
                this.orderSuccess(data)
              })
              .catch(error => {
                this.isOrder = false
                this.formMsg(error)
              });
            }).catch(() => {})
        // }
      },
      orderSuccess(data) {
        this.isOrder = false;
        console.log('orderSuccess data:', data)
        
        // 检查是否是新支付返回结构（兼容 data.new 和 data.result.new 两种情况）
        const isNewPayment = (data.new == true) || (data.result && data.result.new == true);
        const paymentData = data.result || data; // 优先使用 data.result，否则使用 data
        
        if (isNewPayment) {
          // 新支付返回结构
          let paymentType = paymentData.payment_type || 'link';
          let out_trade_no = paymentData.sn || paymentData.order_no || '';
          console.log('paymentType:', paymentType)
          switch(paymentType) {
            case 'qrcode':
              // 显示二维码弹窗
              this.centerDialogVisible = true;
              this.downloadData.url = paymentData.pay_url || '';
              if (out_trade_no) {
                delay(() => {
                  this.checkorder(out_trade_no)
                }, 3000)
              }
              break;
            case 'link':
                // 打开链接
                this.openUrl(paymentData.pay_url);
              break;
            case 'jsapi':
              // jsapi类型：调用微信支付
              this.wxpay(paymentData);
              break;
            case 'app':
              // app类型：调用马甲APP支付
              this.magpay(paymentData);
              break;
            default:
              this.formMsg('暂不支持的支付类型！')
              break;
          }
        } else {
          // 旧支付返回结构，保持原有逻辑
          const results = data.results || data
          const qrcodeUrl = results.qrcode || results.h5_url || data.h5_url
          const tradeNo = results.out_trade_no || data.out_trade_no
          
          switch(this.$client) {
            case 'h5':
              this.centerDialogVisible = true;
              this.downloadData.url = qrcodeUrl
              console.log('二维码URL:', qrcodeUrl)
              if (tradeNo) {
                delay(() => {
                  this.checkorder(tradeNo)
                }, 3000)
              }
              break;
            case 'wxh5':
              let params = results;
              this.wxpay(params);
              break;
            case 'magapp':
              this.magpay(results);
              break;
            default:
              this.formMsg('暂不支持的客户端！')
              break;
          }
        }
      },
      openUrl(url) {
        if (url) {
          window.open(url, '_blank');
        }
        this.$confirm("支付提示","",{
          iconClass: "el-icon-question",//自定义图标样式
            confirmButtonText: "支付完成",//确认按钮文字更换
            cancelButtonText: "取消",//取消按钮文字更换
            showClose: true,//是否显示右上角关闭按钮
            type: "warning",//提示类型  success/info/warning/error
        }).then((data) => {
          this.routeOrderSuccess();
        }).catch((err) => {
          // 取消操作
        });
      },
      formMsg(message) {
        console.log(message)
        this.isOrder = false;
        this.$message({
          message,
          type: "warning"
        })
      },
      routeOrderSuccess() {
        const { id } = this.$route.query
        if (String(id) === '89') {
          this.$router.push({
            path: '/myEsim'
          })
        } else {
          this.$router.push({
            path: '/orderSuccess'
          })
        }
      },
      checkorder(sn) {
        this.$api
        .request('Order/check', {sn})
        .then(({ data }) => {
          // this.formMsg('支付成功')
          // this.$router.go(0);
          this.routeOrderSuccess()
        })
        .catch(error => {
          // console.log(error)
        })
      },
      magpay(params) {
        let config = {
          money: params.pay_amount,
          title: params.description,
          des: params.description,
          payWay: {
            // wallet: 1,
            weixin: 1,
            alipay: 1,
          },
          orderNum: params.oid,
          unionOrderNum: params.order_sn,
          type: params.description
        };
        mag.pay(config, () => {
          setTimeout(() => {
            this.routeOrderSuccess()
            // this.formMsg('支付成功')
          }, 50);
        }, () => {
          this.formMsg('支付失败')
        });
      },
      wxpay(params) {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            'appId': params.appId,
            'timeStamp': params.timeStamp,
            'nonceStr': params.nonceStr,
            'package': params.package,
            'signType': params.signType,
            'paySign': params.sign ? params.sign: params.paySign
          },
          (res) => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              // this.formMsg('支付成功')
              // this.$router.go(0);
              this.routeOrderSuccess()
            } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
              this.$router.go(0);
            }
        });
      },
      // 加载指定分类的产品（ptype7 FortunePay）
      async loadCategoryProducts(id) {
        try {
          const { data } = await this.$api.request('System/getProducts', {
            position: 1,
            client: 'h5',
            cids: '[' + id + ']'
          })
          const list = Array.isArray(data) ? data : []
          const category = list.find(item => String(item.id) === String(id))
          if (!category) { this.initForm(id, this.menuList); return }
          this.title = category.name || ''
          const products = Array.isArray(category.products) ? category.products : []
          if (products.length > 0 && String(products[0].ptype) === '7') {
            this.isPtype7 = true
            this.ptype7Products = products
            this.$set(this.unitList[0], 'title', '缴费项目')
            this.$set(this.unitList[0], 'tips', '请选择缴费项目')
            const options = products.map(p => ({ id: p.id, name: p.name, text: p.name, value: p.id }))
            this.$set(this.unitList[0], 'list', options)
            // 默认选中产品：电费(116)默认选中ID=1690，其余选第一个
            const defaultOpt = (String(id) === '116' && options.find(o => String(o.id) === '1690')) || options[0]
            this.$set(this.unitList[0], 'value', defaultOpt.id)
            this.$set(this.unitList[0], 'name', defaultOpt.name)
            this.$set(this.unit, 'id', defaultOpt.id)
          } else {
            this.initForm(id, this.menuList)
          }
        } catch (e) {
          this.initForm(id, this.menuList)
        }
      },
      // 处理 ptype7（FortunePay）的 param 格式
      analysisPtype7(param) {
        if (!param) { this.formList = []; return }
        let paramList = []
        try { paramList = typeof param === 'string' ? JSON.parse(param) : param } catch (e) { return }
        if (!Array.isArray(paramList)) return
        const initForm = {}
        const list = paramList.map(item => {
          initForm[item.field] = ''
          const cnTitle = this.translateFieldLabel(item.field, item.label)
          // 复合标题（含 "+"）里已有各段位数，tips 不再追加整体位数，避免冗余
          const isComposite = cnTitle.indexOf('+') >= 0
          const lenHint = (!isComposite && item.length && Number(item.length) > 0) ? `（${item.length}位）` : ''
          return {
            key: item.field,
            title: cnTitle,
            tips: '请输入' + cnTitle + lenHint,
            value: '',
            type: 'input',
            inputType: (item.type === 'Number' || item.type === 'Numeric') ? 'digit' : 'text',
            required: !!item.required
          }
        })
        this.$set(this, 'formList', list)
        this.$set(this, 'form', initForm)
      },
      // 表单内容初始化
      async init() {
        const { id } = this.$route.query
        if (String(id) === '89') {
          this.title = 'eSIM'
          await this.initEsimNew()
        } else {
          await this.loadCategoryProducts(id)
        }

        const withdrawRules = JSON.parse(localStorage.getItem('withdrawRules'))
        if (withdrawRules && withdrawRules.length > 0) {
          this.amountLoad = withdrawRules
          this.amountList = withdrawRules.map(item => item.amount)
        }
      },
      // 获取对应表单列表
      initForm(id, list) {
      	// 初始化单位及套餐
      	let unitArray = []
      	// console.log('list:', list)
      	// console.log('id:', id)
        const category = list.find(item => item.id == id)
        if (!category) {
          console.error('找不到ID为', id, '的分类')
          this.title = '未知分类'
          return
        }
        const { name, child_category } = category
        this.title = name
      	if (child_category) {
      		const newUnit = JSON.parse(JSON.stringify(child_category))
      		newUnit.forEach(item => {
      			item.text = item.name
      			item.value = item.id
      		})
      		unitArray = newUnit
      	}
      	this.$set(this.unitList[0], 'list', unitArray)
      	// 缴费金额只要一项则默认选中
      	if (unitArray.length === 1) {
      		this.$set(this.unit, 'id', unitArray[0].id)
      	}
        // 如果 id = 81 且有国家列表，默认选择第一个国家
        if (id == 81 && unitArray.length > 0) {
          // 默认选择第一个国家
          this.$set(this.unit, 'id', unitArray[0].id)
          // 同时更新unitList中对应项的name，用于显示选中的国家名称
          this.$set(this.unitList[0], 'title', '国家')
          this.$set(this.unitList[0], 'name', unitArray[0].name)
          // 设置当前选中的单位信息
          this.$set(this.unitList[0], 'value', unitArray[0].id)
          
          // 注意：这里不需要手动触发套餐选择逻辑
          // 因为watch中的'unit.id'监听器会自动处理后续逻辑
          // 包括：重置套餐、获取套餐列表、选择第一个套餐等
        }
      	// 初始化其它表单信息
      	// const initList = lifeSelect[type]
      	// this.formList = JSON.parse(JSON.stringify(initList))
      },
      // 获取我的 eSIM 列表，并构建 iccid 下拉框
      async buildEsimIccidSelect() {
        try {
          const res = await this.$api.request('Member/myEsims', {})
          const list = res && Array.isArray(res.data) ? res.data : []
          const options = list.map(item => ({
            id: String(item.iccid),
            name: item.package_title ? `${item.package_title} (${item.package_id})` : String(item.package_id)
          }))
          const placeholder = { id: '', name: '新购' }
          const finalOptions = [placeholder, ...options]
          this.$set(this.iccidFormList[0], 'list', finalOptions)
          this.$set(this.iccidFormList[0], 'value', '')
          this.$set(this.iccidFormList[0], 'name', placeholder.name)
        } catch (error) {
          this.$set(this.iccidFormList[0], 'list', [])
          this.$set(this.iccidFormList[0], 'value', '')
        }
      },
      // eSIM-New 初始化
      async initEsimNew() {
        this.isEsimNew = true
        this.loadTitle = '加载数据中...'
        this.isOrder = true
        try {
          const { data } = await this.$api.request('System/getRechargeCategoryTree', { position: 1, client: 'h5' })
          const esimCategory = data.find(item => String(item.id) === '89')
          if (!esimCategory || !Array.isArray(esimCategory.children)) {
            this.$message({ message: '找不到eSIM分类数据，请稍后重试', type: 'warning' })
            return
          }
          this.continents = esimCategory.children
          await this.buildEsimIccidSelect()
        } catch (error) {
          this.$message({ message: '获取分类数据失败，请检查网络！', type: 'warning' })
          return
        } finally {
          this.isOrder = false
        }
        const allCountries = []
        this.continents.forEach(cont => { if (Array.isArray(cont.children)) cont.children.forEach(co => allCountries.push(co)) })
        this.countriesAll = allCountries
        const unitArray = allCountries.map(c => ({ ...c, text: c.name, value: c.id }))
        this.$set(this.unitList[0], 'list', unitArray)
        this.$set(this.unitList[0], 'title', '国家')
        const lastId = localStorage.getItem('esim_selected_country_id')
        if (lastId) {
          const lastCountry = allCountries.find(c => String(c.id) === String(lastId))
          if (lastCountry) { this.applyCountry(lastCountry, false); return }
        }
        this.countryDialogVisible = true
      },
      // 洲/国家选择
      selectContinent(continentId) { this.selectedContinentId = continentId },
      selectCountry(country) { this.applyCountry(country, true) },
      applyCountry(country, close) {
        this.selectedCountry = country
        const idx = this.fakeCountryFormList.findIndex(i => i.key === 'country')
        if (idx !== -1) {
          this.$set(this.fakeCountryFormList[idx], 'name', country.name)
          this.$set(this.fakeCountryFormList[idx], 'value', country.id)
        }
        this.$set(this.unitList[0], 'title', '国家')
        this.$set(this.unitList[0], 'name', country.name)
        this.$set(this.unitList[0], 'value', country.id)
        this.$set(this, 'unit', { id: country.id })
        localStorage.setItem('esim_selected_country_id', String(country.id))
        if (close) this.countryDialogVisible = false
      },
      setFormData(i, k, v) {
        this.$set(this.formList[i], k, v)
      }
    }
  }
</script>

<style lang="less" scoped>
  .place-order {
    padding-top: 146px;
    padding-bottom: 80px;

    .coupon-code {
    	padding: 0 16px;
    	margin-top: 30px;

    	.life-form-item {
    		height: 56px;
    		background: #F8F8FA;
    		border: 1px solid #E2E3E4;
    		border-radius: 16px;
    		padding: 0 18px 0 6px;
    		margin-bottom: 7.5px;

    		&:last-child {
    			margin-bottom: 0 !important;
    		}

    		.form-item-title {
    			font-family: Poppins;
    			font-size: 16px;
    			color: #686777;
    			font-weight: 500;
    			line-height: 40px;
    		}

    		.code-btn {
    			color: #ED3A42 !important;
    		}

    		.code-input {
    			input {
    				padding-left: 0 !important;
    			}
    		}

    		.form-item-value {
    			justify-content: flex-end;
    			min-width: 0;

    			.form-item-select {
    				width: 100%;
    			}

    			input {
    			  width: 100%;
    			  font-size: 16px;
    			  color: #686777;
    			  height: 24px;
    			  font-weight: 500;
    			  text-align: left;
    			  padding-left: 10px !important;
            background: none;
            outline: none;
            border: none;
    			}

    			span {
    			  font-size: 16px;
    			  color: #ED3A42;
    			  display: block;
    			}
    		}
    	}
    }

    .unit {
    	margin-top: 38px;
    	position: relative;
    	z-index: 100;
    	
    	// 提高下拉框的 z-index，避免被下面的输入框遮挡
    	/deep/ .el-select-dropdown {
    		z-index: 1000 !important;
    	}
    	/deep/ .el-select {
    		z-index: 100 !important;
    	}
    	
    	.sub {
    		display: flex;
    		flex-wrap: wrap;
    		margin-top: 16px;
    		padding: 0 16px;
    		.item {
    			width: calc((100% - 15px) / 2);
    			margin-right: 15px;
    			height: 55px;
    			background: #fff;
    			border-radius: 5px;
    			border: 1px solid #F66448;
    			display: flex;
    			justify-content: center;
    			align-items: center;
    			flex-direction: column;
    			margin-top: 15px;
    			padding: 0 5px;
    			&:nth-child(2n) {
    				margin-right: 0;
    			}
    			&:nth-child(-n+2) {
    				margin-top: 0;
    			}
    			.package-price {
    				font-size: 15px;
    				color: #F66448;
    				transition: .5s;
    				font-weight: bold;
    				line-height: 16px;
    			}
    			.name {
    				font-size: 11px;
    				color: #F66448;
    				line-height: 12px;
    				transition: .5s;
    				margin-top: 5px;
            font-weight: bold;
    				text {
    					font-size: 17px;
    					font-family: Arial;
    					font-weight: bold;
    				}
    			}
    		}
    		.active {
    			background: #FFDAD3;
    			transition: all .4s;
    		}
    	}
    }
    .place-order-form {
    	margin-top: 15px;
    	position: relative;
    	z-index: 1; // 确保输入框的层级低于下拉框
    }

    // .place-order-form {
    //   margin-top: 38px;
    // }

    .place-order-etc {
      // padding: 0 38px;
      padding: 0 16px;
      margin-top: 23px;

      .etc-select-title {
        font-family: Poppins;
        font-size: 18px;
        color: #686777;
        font-weight: 600;
        line-height: 27px;
        margin-bottom: 16px;
        text-align: center;
      }
    }

    .place-order-notice {
      // margin-top: 71px;
      margin-top: 30px;
      padding: 0 11px 0 16px;
    }

    .meo-tips {
      margin-top: 35px;
      padding: 0 16px;
      box-sizing: border-box;
      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }
  }
/* 国家选择器样式 */
.country-picker {
  display: flex;
  height: calc(100% - 102px);
  width: 100%;
  overflow: hidden;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 102px;
}
.country-picker .left-pane {
  width: 30%;
  border-right: 1px solid #ddd;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  background-color: #f5f5f5;
  -webkit-overflow-scrolling: touch;
}
.country-picker .right-pane {
  width: 70%;
  padding: 0;
  overflow-y: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 6px;
  align-content: start;
  background-color: #fff;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
  padding: 6px;
}
.left-item {
  padding: 10px 5px;
  cursor: pointer;
  border-radius: 4px;
  margin: 4px 3px;
  background: #e8e8e8;
  border: 1px solid #ddd;
  font-size: 15px;
  color: #555;
  user-select: none;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: calc(100% - 6px);
  min-width: 75px;
  font-weight: 500;
}
.right-item {
  padding: 10px 5px;
  cursor: pointer;
  border-radius: 6px;
  margin: 3px;
  background: #F8F8FA;
  border: 1px solid #E2E3E4;
  font-size: 14px;
  color: #686777;
  user-select: none;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}
.left-item.active {
  background: #AB3331;
  border-color: #AB3331;
  color: #fff;
  font-weight: 600;
}
.right-item.active {
  background: #FFDAD3;
  border-color: #F66448;
  color: #F66448;
  font-weight: 600;
}
/* 自定义全屏弹窗样式 - 强制覆盖所有样式 */
.country-overlay {
  position: fixed;
  z-index: 2999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: flex-end;
}
.country-sheet {
  position: relative;
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
  height: 60vh;
  max-height: 720px;
  background: #fff;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  overflow: hidden;
  box-shadow: 0 -6px 16px rgba(0,0,0,0.12);
  animation: slideUp .22s ease-out;
}
@keyframes slideUp {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}
.country-picker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  background-color: #AB3331;
  color: white;
  padding: 0 15px;
  position: relative;
  z-index: 10;
}
.country-picker-header .close-button { width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; cursor: pointer; border-radius: 50%; }
.country-picker-header .close-button i { font-size: 18px; }
.country-search { position: absolute; top: 50px; left: 0; right: 0; padding: 8px 10px; background: #fff; z-index: 9; box-shadow: 0 1px 0 rgba(0,0,0,0.06); }
.country-search-input { width: 100%; height: 36px; border: 1px solid #E2E3E4; border-radius: 8px; padding: 0 12px; font-size: 14px; outline: none; }
.country-picker-header .header-title { font-size: 18px; font-weight: 500; }
.country-picker-header .header-space { width: 50px; }
.country-selector { position: relative; cursor: pointer; }
.country-selector::after { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; }
/* ptype7 缴费项目选择器 */
.ptype7-selector { padding: 0 16px; cursor: pointer; }
.ptype7-trigger-item {
  height: 56px;
  background: #F8F8FA;
  border: 0.5px solid #E2E3E4;
  border-radius: 16px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}
.ptype7-trigger-title { font-size: 16px; color: #686777; font-weight: 500; white-space: nowrap; }
.ptype7-trigger-value {
  flex: 1;
  text-align: right;
  font-size: 16px;
  color: #c8c7ce;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-left: 12px;
}
.ptype7-trigger-value.has-value { color: #686777; }
.ptype7-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 3000;
  display: flex;
  align-items: flex-end;
}
.ptype7-sheet {
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
  background: #fff;
  border-radius: 16px 16px 0 0;
  height: 70vh;
  display: flex;
  flex-direction: column;
  animation: slideUp .22s ease-out;
}
.ptype7-sheet-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #E2E3E4;
  flex-shrink: 0;
}
.ptype7-sheet-title { font-size: 16px; font-weight: 600; color: #333; }
.ptype7-sheet-close { font-size: 20px; color: #999; cursor: pointer; }
.ptype7-sheet-search { padding: 12px 16px; border-bottom: 1px solid #f0f0f0; flex-shrink: 0; }
.ptype7-search-input {
  width: 100%;
  height: 36px;
  background: #F8F8FA;
  border: 1px solid #E2E3E4;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
}
.ptype7-sheet-list { overflow-y: auto; flex: 1; padding: 8px 0; -webkit-overflow-scrolling: touch; }
.ptype7-list-item {
  padding: 14px 20px;
  font-size: 15px;
  color: #333;
  cursor: pointer;
  border-bottom: 0.5px solid #f5f5f5;
}
.ptype7-list-item.active { color: #409EFF; font-weight: 500; background: #f0f7ff; }
.ptype7-empty { padding: 20px; text-align: center; color: #999; font-size: 14px; }

/* 支付类型和支付方式样式 */
.payment-type, .payment-method {
  padding: 0 16px;
  margin-top: 15px;
}

.payment-method.life-form-item {
  align-items: flex-start;
}

.payment-type-radio .myredioBox {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.payment-type-radio .myredioleabl {
  width: auto;
  min-width: 80px;
  margin-left: 15px;
  justify-content: flex-start;
  cursor: pointer;
}

.payment-method-list {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
}

.payment-method-list .payment-item {
  margin-left: 0;
  margin-bottom: 0;
  margin-right: 0;
}

.payment-method-list .myredioleabl {
  width: auto;
  min-width: 80px;
  padding: 8px 12px;
  justify-content: flex-start;
  cursor: pointer;
  border: 1px solid #E2E3E4;
  border-radius: 8px;
  background: #F8F8FA;
}

.payment-method-list .myredioleablAc {
  border-color: #F66448;
  background: #FFDAD3;
}

.payment-method-list .myrediotext {
  display: flex;
  align-items: center;
  justify-content: center;
}

.payment-item-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  flex-direction: row;
  flex: 1;
}

.payment-icon {
  height: 20px;
  width: auto;
  max-width: 80px;
  min-width: 20px;
  display: inline-block;
  object-fit: contain;
  vertical-align: middle;
  flex-shrink: 0;
}

.payment-name {
  font-size: 14px;
  color: #4D4F53;
  white-space: nowrap;
}

/* 单选按钮样式 */
.myredioBox {
  display: flex;
  align-items: center;
}

.myredioleabl {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 23px;
  line-height: 23px;
  color: #4D4F53;
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 400;
}

.myrediotext {
  color: #4D4F53;
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  margin-left: 2px;
}

.myredio {
  width: 14px;
  height: 14px;
  background-color: #ffffff;
  border-radius: 50%;
  margin-right: 2px;
  border: 1px solid rgb(104, 103, 119);
  display: flex;
  justify-content: center;
  align-items: center;
}

.myredioleabl .myredio {
  border: 0.3px solid rgb(104, 103, 119);
}

.myredioleablAc .myredio {
  border: 0.3px solid rgb(180, 32, 39);
}

.myredioleabl .myredio div {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #FFFFFF;
}

.myredioleablAc .myredio div {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgb(180, 32, 39);
}
</style>



// WEBPACK FOOTER //
// src/page/placeOrder.vue